import React from 'react';
import WpIcon from 'Wpds/components/icon/WpIcon';

import './SearchInput.scss';

type Props = {
  inputRef?: {
    current: HTMLInputElement;
  };
  value: string;
  placeholder?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
};

function SearchInput({ value, onChange, placeholder = '', className = '', inputRef }: Props) {
  return (
    <div className={`search-input ${className}`}>
      <div className="search-input-icon">
        <WpIcon name="search" />
      </div>
      <input
        ref={inputRef}
        type="text"
        className="form-control"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  );
}

export default SearchInput;
